import PropType from "prop-types";
import { useDispatch } from 'react-redux';
import { withRouter } from "react-router-dom";
import styles from "./style.module.scss";
import creditzActions from '../../../../../redux/creditz/actions';

const VideoCard = ({ video = {}, username, history }) => {
  const dispatch = useDispatch();

  const viewVideo = () => {
    dispatch({
      type: creditzActions.SET_STATE,
      payload: { viewCreditzProfile: video},
    });
    history.push("/creditz")
  }
  return (
    <div className={styles.cardContainer}>
      <div className={styles.imageContainer}>
        <div className={styles.layer1} />
        <div className={styles.layer2} />
        <div
          className={styles.image}
          style={{ backgroundImage: `url(${video.videoImage})` }}
        />
      </div>
      <div className={styles.songTitle}>‘{video.videoTrackName}’</div>
      <p className={styles.description}>
        by {video.artistName ? video.artistName : username}
      </p>
      <div className={styles.typeContainer}>
        <span className={styles.type}>{video.role}</span>
      </div>
      <button onClick={()=>viewVideo()}>View</button>
    </div>
  );
};

VideoCard.propTypes = {
  video: PropType.object,
  history: PropType.object,
  username: PropType.string,
};

export default withRouter(VideoCard);
